import React from "react";
import "../static/brands.css";
import { BRANDS_LIST, BRANDS_LOGO } from "../../../utils/consts";
function Brands() {
  return (
    <div>
      <div className="listenToText margin-top-11 margin-bottom-11 brandsLineHeight m-auto col-xl-9 col-lg-9 col-md-9 mb-5 text-center">
        Ombre has filled the room with fans for our partners
      </div>
      <div className="conductEventsTitle successEventTitle text-center col-xl-12 col-lg-12 col-md-12 mx-auto d-none d-xl-none d-lg-none d-md-none d-sm-block d-block mt-sm-4 mt-4">
        Brands Associated with Ombre
      </div>
      <div>
        <div className="container-fluid d-flex flex-row overflow-auto artistContainer eventsContainer  pt-xl-3 pt-lg-3 pt-md-3 pt-sm-2 pt-2 pl-xl-7 pl-lg-5 pl-md-5 pl-sm-0 pl-0">
          {BRANDS_LOGO.map((brand, idx) => {
            return (
              <div className="brandCard p-sm-3 p-3">
                <div className="row flex-column justify-content-center">
                  <img
                    className="brandImage rounded-circle bg-white mx-auto mb-sm-3 mb-3"
                    src={brand.image}
                  />
                  <div className="curatedDescription artistName  text-center">
                    {brand.key}
                  </div>
                  {/* <div className="d-none d-xl-block d-lg-block d-md-block text-center m-auto">
                  <div className="artistBio truncate-overflow col-xl-12 px-0 py-2">
                    {artist.bio}
                  </div>
                </div> */}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default Brands;



// WEBPACK FOOTER //
// ./src/pages/ContactUs/components/Brands.jsx